/**
 * Housing Unit Card Selected Epic
 *
 * Reacts to housingUnitCardSelected actions and dispatches navigateTo to switch to housing
 * unit detail with resolved lot context preserved.
 *
 * @param {object} params
 * @param {object} params.dataActions - Actions from the feature data slice instance
 * @param {Observable} params.store$ - Redux store state observable
 * @returns {import('redux-observable').Epic}
 */

import { map, withLatestFrom } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { VIEW_HOUSING_UNIT_DETAIL } from '../constants';
import { selectSelectedLotId, selectHousingUnits, selectLotsById } from './selectors';

function createHousingUnitCardSelectedEpic({ dataActions, store$ }) {
  return (action$) => action$.pipe(
    ofType(dataActions.housingUnitCardSelected.type),
    withLatestFrom(store$),
    map(([action, state]) => {
      const selectedLotId = selectSelectedLotId(state) ?? null;
      const housingUnits = selectHousingUnits(state);
      const lotsById = selectLotsById(state);
      const housingUnitId = Number(action.payload);
      const housingUnit = housingUnits.find((unit) => (
        unit.specificationId === housingUnitId || unit.housingUnitId === housingUnitId
      )) ?? null;
      const lot = housingUnit ? lotsById[housingUnit.lotId] ?? null : null;

      return dataActions.navigateTo({
        view: VIEW_HOUSING_UNIT_DETAIL,
        context: {
          planId: null,
          selectedLotId: lot?.sitePlanLotId ?? selectedLotId,
          housingUnitId: housingUnit?.specificationId ?? housingUnitId,
        },
      });
    }),
  );
}

export default createHousingUnitCardSelectedEpic;
